var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"realtime-subtitles"},_vm._l((_vm.displayedLines),function(line,index){return _c('span',{key:index,staticClass:"subtitle-line"},[_vm._v(_vm._s(line))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }